module.exports = __webpack_public_path__ + "img/item10.34796793.png";